var swiper = new Swiper(".topbarsswiper", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});

var swiper = new Swiper(".homeslider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  speed: 2000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});

var swiper = new Swiper(".homepiconsdeat", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:4,
      spaceBetween:5,
    },
    768: {
      slidesPerView: 4,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:7,
      spaceBetween:10,
    },
  },
});



var swiper = new Swiper(".youMaylikke", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:2,
      spaceBetween:10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView:4,
      spaceBetween: 50,
    },
  },
});

var swiper = new Swiper(".byskintype", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:2,
      spaceBetween:10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:20,
    },
  },
});

var swiper = new Swiper(".byskinconcerns", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:2,
      spaceBetween:10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:20,
    },
  },
});

var swiper = new Swiper(".awardssec", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:3,
      spaceBetween:10,
    },
    768: {
      slidesPerView:4,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:6,
      spaceBetween:30,
    },
  },
});

var swiper = new Swiper(".blogssldiers", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:1,
      spaceBetween:10,
    },
    768: {
      slidesPerView:2,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:3,
      spaceBetween:30,
    },
  },
});


var swiper = new Swiper(".happycustomer", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }, 
  

  breakpoints: {
    0: {
      slidesPerView:1.3,
      spaceBetween:10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:20,
    },
  },
});

var swiper = new Swiper(".homepagetabs", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  
  breakpoints: {
    0: {
      slidesPerView:1.6,
      spaceBetween:10,
    },
    768: {
      slidesPerView:3,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:30,
    },
  },
});

var swiper = new Swiper(".asseeninsec", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:3,
      spaceBetween:10,
    },
    768: {
      slidesPerView:4,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:6,
      spaceBetween:30,
    },
  },
});


var swiper = new Swiper(".customcollection", {
  slidesPerView: 1,
  spaceBetween:20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:2,
    },
    768: {
      slidesPerView:3,
    },
    1024: {
      slidesPerView:4,
    },
  },
});



var swiper = new Swiper(".youmayalsolike", {
  slidesPerView: 1,
  spaceBetween:20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:2,
      spaceBetween:10,
    },
    768: {
      slidesPerView:3,
    },
    1024: {
      slidesPerView:4,
    },
  },
});



var swiper = new Swiper(".prestigiousaw", {
  slidesPerView: 1,
  spaceBetween: 10,
  // navigation: {
  //   nextEl: ".swiper-button-next",
  //   prevEl: ".swiper-button-prev",
  // },

  breakpoints: {
    0: {
      slidesPerView:3,
      spaceBetween:10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween:20,
    },
    1024: {
      slidesPerView:3,
      spaceBetween: 50,
    },
  },
});


var swiper = new Swiper(".productthumbs2", {
  spaceBetween: 10,
  slidesPerView:7,
  freeMode: true,
  watchSlidesProgress: true,
});
var swiper2 = new Swiper(".productthumbs", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});


$(".result").hover(function () {
   $(this).toggleClass("result_hover");
});



$('.nav-toggle1').click(function(){
	$('.nav-toggle1').toggleClass('active');
  $('.nav-items1').slideToggle();
});

$('.nav-toggle2').click(function(){
	$('.nav-toggle2').toggleClass('active');
  $('.nav-items2').slideToggle();
});

$('.nav-toggle3').click(function(){
	$('.nav-toggle3').toggleClass('active');
  $('.nav-items3').slideToggle();
});

$('.nav-toggle4').click(function(){
	$('.nav-toggle4').toggleClass('active');
  $('.nav-items4').slideToggle();
});

$('.nav-toggle5').click(function(){
	$('.nav-toggle5').toggleClass('active');
  $('.nav-items5').slideToggle();
});



(function () {
  "use strict";
  var jQueryPlugin = (window.jQueryPlugin = function (ident, func) {
    return function (arg) {
      if (this.length > 1) {
        this.each(function () {
          var $this = $(this);

          if (!$this.data(ident)) {
            $this.data(ident, func($this, arg));
          }
        });

        return this;
      } else if (this.length === 1) {
        if (!this.data(ident)) {
          this.data(ident, func(this, arg));
        }

        return this.data(ident);
      }
    };
  });
})();

(function () {
  "use strict";
  function Guantity($root) {
    const element = $root;
    const quantity = $root.first("data-quantity");
    const quantity_target = $root.find("[data-quantity-target]");
    const quantity_minus = $root.find("[data-quantity-minus]");
    const quantity_plus = $root.find("[data-quantity-plus]");
    var quantity_ = quantity_target.val();
    $(quantity_minus).click(function () {
      quantity_target.val(--quantity_);
    });
    $(quantity_plus).click(function () {
      quantity_target.val(++quantity_);
    });
  }
  $.fn.Guantity = jQueryPlugin("Guantity", Guantity);
  $("[data-quantity]").Guantity();
})();


function copyToClipboard(element) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
}



// Get the modal
var modal = document.getElementById('myModal1');
// Get the button that opens the modal
var btn = document.getElementById("myBtn1");
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[1];
// When the user clicks the button, open the modal
btn.onclick = function() {
    modal.style.display = "block";
}
// When the user clicks on <span> (x), close the modal
span.onclick = function() {
    modal.style.display = "none";
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}



// Get the modal
var modal = document.getElementById('myModal2');
// Get the button that opens the modal
var btn = document.getElementById("myBtn2");
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[2];
// When the user clicks the button, open the modal
btn.onclick = function() {
    modal.style.display = "block";
}
// When the user clicks on <span> (x), close the modal
span.onclick = function() {
    modal.style.display = "none";
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}


